import { useEffect } from 'react';
import { UseFormSetValue, FieldPath, FieldValues } from 'react-hook-form';

interface UseIncludeAllSyncParams<T extends FieldValues> {
    includeAll: boolean;
    selected: string[];
    excluded: string[];
    selectedPath: FieldPath<T>;
    excludedPath: FieldPath<T>;
    setValue: UseFormSetValue<T>;
}

const useIncludeAllSync = <T extends FieldValues>({
    includeAll,
    selected,
    excluded,
    selectedPath,
    excludedPath,
    setValue,
}: UseIncludeAllSyncParams<T>) => {
    useEffect(() => {
        if (includeAll && selected.length > 0) {
            setValue(selectedPath, [] as any, { shouldValidate: false });
        }
    }, [includeAll, selected.length, selectedPath, setValue]);

    useEffect(() => {
        if (!includeAll && excluded.length > 0) {
            setValue(excludedPath, [] as any, { shouldValidate: false });
        }
    }, [includeAll, excluded.length, excludedPath, setValue]);
};

export default useIncludeAllSync;
